import { LoadingIcon, Stack } from '@cash-design-system/react'
import { ClientScenario } from '@cash-web/protos/squareup/franklin/api/client_scenario.pb'
import { useMutationCompleteScenario } from '@cash-web/shared-data-access-api/react-query'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { FlowStartProps } from '@cash-web/shared-flow-data-access-context'
import { useExecuteOnce } from '@cash-web/shared-util-execute-once'

type CompleteScenarioProps = {
  clientScenario: ClientScenario
  flowToken?: string
}

export const CompleteScenario = ({ clientScenario, flowToken }: CompleteScenarioProps) => {
  const flowConfig: FlowStartProps = {
    clientScenario: clientScenario,
    trackingFlowName: clientScenario,
    queriesToInvalidate: 'ALL',
    flowToken,
  }

  const flow = useFlowContext()

  // Call complete scenario here instead delegating to `useFlow` to include optional middleware
  const { mutateAsync: completeScenario } = useMutationCompleteScenario()

  useExecuteOnce(() => {
    flow.startWithResponse({
      ...flowConfig,
      response: completeScenario({
        options: { clientScenario: flowConfig.clientScenario, flowToken: flowConfig.flowToken },
      }),
    })
  })

  return (
    <Stack space="l" justifyItems="center">
      <LoadingIcon />
    </Stack>
  )
}
